import { Link } from "@tanstack/react-router";
import type { HtOkumaCipi as HtOkumaCipiVerisi } from "@oasis/domain";
import { Etiket } from "@/components/parcalar";
import { cevir } from "@/lib/dil";
import { tarih } from "@/lib/veri";

/**
 * D-074 Faz 2 · PR 8 (T28, T29): kabul edilmiş hidrotest sertifikasının Documents okuması, YALNIZ GÖSTERİM (Finishing, Repair planning ve Riser
 * Documentation 3.5 aynı çipi çizer). Açık sarı ya da kırmızı uyarı varsa "Document alerts: {kodlar}" (kırmızı varsa kırmızı) ve Documents
 * kartına bağlantı; KIM-02 "File to a line" ya da KIM-01 "File here" kararı varsa sarı "Filed with … difference" (title: kim, tarih, gerekçe);
 * okuma var, açık uyarı yoksa gri "Read: no open alerts". Okuma yoksa hiçbir şey çizilmez. Hat durumu, düğmeler ve kurallar bunu okumaz.
 */
export function HtOkumaCipi({ o }: { o: HtOkumaCipiVerisi | null | undefined }) {
  if (!o) return null;
  const kirmizi = o.acik.some((u) => u.renk === "kirmizi");
  const kodlar = o.acik.map((u) => u.kod).join(" · ");
  const fark = o.farkla;
  return (
    <>
      {o.acik.length > 0 && (
        <Link to="/belgeler" hash={`belge-${o.gelenId}`} data-ht-okuma="acik">
          <Etiket tone={kirmizi ? "bad" : "warn"}>{cevir("Document alerts: {0}", kodlar)}</Etiket>
        </Link>
      )}
      {fark && (
        <span
          data-ht-okuma="farkla"
          title={cevir(fark.tur === "sn" ? "Filed with an SN difference: {0}, {1}, {2}." : "Filed with a riser-number difference: {0}, {1}, {2}.", fark.kim, tarih(fark.ts), cevir(fark.gerekce))}
        >
          <Etiket tone="warn">{cevir(fark.tur === "sn" ? "Filed with an SN difference" : "Filed with a riser-number difference")}</Etiket>
        </span>
      )}
      {o.acik.length === 0 && !fark && <span data-ht-okuma="okundu"><Etiket>{cevir("Read: no open alerts")}</Etiket></span>}
    </>
  );
}
